export function resolveValueByPath(path: string | undefined, data: any) {
  if (!path) return
  const keys = path.split('.')

  let value = data
  for (const key of keys) {
    value = value[key]
  }

  return value
}
